import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  USER_RESET_PASSWORD_ERROR,
  USER_RESET_PASSWORD_LOADING,
  USER_RESET_PASSWORD_SUCCESS,
  USER_RESET_PASSWORD_RESET
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  success: null
};

function error(error) {
  return {type: USER_RESET_PASSWORD_ERROR, error};
}

function loading(loading) {
  return {type: USER_RESET_PASSWORD_LOADING, loading};
}

function success(success) {
  return {type: USER_RESET_PASSWORD_SUCCESS, success};
}

function reset() {
  return {type: USER_RESET_PASSWORD_RESET};
}

const getters = {
  error: state => state.error,
  success: state => state.success,
  loading: state => state.loading,
};

const actions = {
  resetPassword({ commit }, item) {
    commit(loading(true));
    commit(error(null));

   return http.fetch('/users/' + item.id + '/send-password-token', {method: 'PUT'})
      .then(() => {
        commit(loading(false));
        commit(success(item));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(error(e.message));
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [USER_RESET_PASSWORD_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [USER_RESET_PASSWORD_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [USER_RESET_PASSWORD_SUCCESS] (state, payload) {
      state.success = payload.success;
    },
    [USER_RESET_PASSWORD_RESET] (state) {
      state.error = '';
      state.loading = false;
      state.success = null;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user/reset-password.js